import script from "./ListarAnimais.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarAnimais.vue?vue&type=script&setup=true&lang=js"

import "./ListarAnimais.vue?vue&type=style&index=0&id=2cb11660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb11660"]])

export default __exports__